import GradientBorder from "@core-components/gradient-border/GradientBorder";
import Icon from "@core-components/icon/Icon";
import { EExternalRoutes } from "@core-types/routes.enum";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import { Trans } from "react-i18next";
import { Link } from "react-router";
import { ReviewHelper } from "../utils/Review.helper";
import Grade from "./Grade";

const GlobalGrade = () => {
  const { t } = useAppTranslation("pages.reviews");

  return (
    <Link
      to={EExternalRoutes.TRUSTPILOT_REVIEWS}
      target="_blank"
      className="text-2xl no-underline"
    >
      <GradientBorder
        className={
          "gradient-blue-to-transparent w-fit items-center justify-center rounded-xl"
        }
        childrenClassName="!bg-primary-default text-primary-white font-bold justify-center items-center py-1 px-4 font-secret flex"
      >
        <Group className="w-fit" justify="center" align="center">
          <Group gap={"xs"} className="text-[18px]">
            <Trans
              i18nKey="statistic"
              t={t}
              values={{ count: ReviewHelper.REVIEW_COUNT }}
            >
              {ReviewHelper.REVIEW_COUNT}
              <div className="font-semibold">Avis vérifiés</div>
            </Trans>
          </Group>

          <div>
            <Icon.TrustpilotStartFilled className="pb-1" size={22} />
          </div>

          <Group gap={"sm"}>
            {t("grade", { grade: ReviewHelper.AVERAGE_GRADE })}
            <Grade grade={5} author="trustpilot" />
          </Group>
        </Group>
      </GradientBorder>
    </Link>
  );
};

export default GlobalGrade;
